/**
 * Classic E: fireflies patrol rings round brick bins of diamonds (docs/spec/03 §2). A firefly
 * keeps the bin on its left, so it ignores tunnels from outside but dives into holes in the bin.
 */

import type { CaveDef } from '../types';

export const caveE: CaveDef = {
  id: 'E',
  name: 'SENTRIES',
  hint: 'Every store has a guard. Learn its rounds.',
  intermission: false,
  colors: [11, 10, 7],
  diamondValue: 15,
  extraValue: 25,
  fill: { base: '.', items: [['r', 10], ['d', 3]] },
  levels: [
    { seed: 1501, diamonds: 15, time: 150 },
    { seed: 1502, diamonds: 18, time: 140 },
    { seed: 1503, diamonds: 21, time: 135 },
    { seed: 1504, diamonds: 24, time: 125 },
    { seed: 1505, diamonds: 27, time: 120 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...?????.???.?????????????.???.???????W',
    'W.P.????...?...???????????...?...??????W',
    'W...??www.www.www???????www.www.www????W',
    'W?????w       f w???????w       f w????W',
    'W?????w wdddddw w???????w wdddddw w????W',
    'W?????w wdddddw w???????w wdddddw w????W',
    'W?????w wwwwwww w???????w wwwwwww w????W',
    'W?????w         w???????w         w????W',
    'W?????wwwwwwwwwww???????wwwwwwwwwww????W',
    'W??????????????????????????????????????W',
    'W???????.??.???????????.????.???.??????W',
    'W??????......?????????...??...?...?????W',
    'W???wwww.ww.www?????www.wwww.www.ww????W',
    'W???w       f w?????w           f w????W',
    'W???w wdddddw w?????w wdddddddddw w????W',
    'W???w wdddddw w?????w wdddddddddw w????W',
    'W???w wdddddw w?????w wwwwwwwwwww w????W',
    'W???w wwwwwww w?????w F           w????W',
    'W???w         w?????wwwwwwwwwwwwwww??X?W',
    'W???wwwwwwwwwww????????????????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
